import { ElementType, VisualizationSettings } from '../../../types';

// ─── Toggle types ───────────────────────────────────────────────────

export type SettingKey = keyof VisualizationSettings;

export interface ToggleDef {
    key: SettingKey;
    label: string;
    short: string;
    appliesTo?: ElementType[];
}

// ─── Toggle definitions ─────────────────────────────────────────────

export const ALL_TOGGLES: ToggleDef[] = [
    { key: 'elementVisibility', label: 'Visibility', short: 'VIS' },
    { key: 'forCones', label: 'FOR Cone', short: 'FOR', appliesTo: ['satellite', 'groundstation'] },
    { key: 'fovCones', label: 'FOV Cone', short: 'FOV', appliesTo: ['satellite', 'groundstation'] },
    { key: 'orbitTracks', label: 'Orbit Tracks', short: 'ORB', appliesTo: ['satellite'] },
    { key: 'trajectoryTrails', label: 'Trajectory Trail', short: 'TRL', appliesTo: ['missile', 'aircraft', 'vessel'] },
    { key: 'orientationAxes', label: 'Orientation Axis', short: 'AXS', appliesTo: ['satellite', 'aircraft', 'vessel', 'missile'] },
    { key: 'commLines', label: 'Comm Lines', short: 'COM' },
];

export const getTogglesForType = (type: ElementType): ToggleDef[] =>
    ALL_TOGGLES.filter(t => !t.appliesTo || t.appliesTo.includes(type));

// ─── Element type metadata ──────────────────────────────────────────

export const TYPE_META: { type: ElementType; label: string; fullLabel: string; color: string }[] = [
    { type: 'satellite', label: 'SAT', fullLabel: 'Satellites', color: '#E6A64E' },
    { type: 'groundstation', label: 'GS', fullLabel: 'Ground Stations', color: '#1E90FF' },
    { type: 'missile', label: 'MSL', fullLabel: 'Threat', color: '#FF4444' },
    { type: 'aircraft', label: 'AIR', fullLabel: 'Aircraft', color: '#00BFFF' },
    { type: 'vessel', label: 'VES', fullLabel: 'Vessels', color: '#00CED1' },
    { type: 'unknown', label: '???', fullLabel: 'Unknown', color: '#888' },
];
